window.infiniteScroll = {

  // variável criada no arquivo _infinity_scroll.liquid
  pagination: window._pagination,

  // wrapper que contém/recebe os produtos
  productsWrapper: document.querySelector('[data-products-wrapper]'),

  // elemento que ativa a busca por mais produtos
  loadEl: document.querySelector('[data-load-more]'),

  stopLoading: function () {
    const loadEl = this.loadEl;
    if (loadEl != null) loadEl.parentElement.removeChild(loadEl);
  },

  setCurrentPage: function (_number) {
    const _this = this;
    const totalPages = _this.pagination.total_pages;

    // Verifica se a página atual não é maior que o total de páginas
    if (_number <= totalPages) {

      // Atualiza a página atual
      _this.pagination.current_page = _number;

      // Desabilita prosseguimento caso tenha chegado na última página, removendo o elemento que dá trigger
      if (_this.pagination.current_page >= totalPages) _this.stopLoading();

      // Atualiza a URL da próxima página
      if (_number < totalPages)
        return _this.pagination.next_url = _this.pagination.pages[_number].url
    }
  },

  loadProducts: async function () {
    const nextUrl = this.pagination.next_url;

    // Busca próxima leva de produtos
    const response = await fetch(nextUrl);
    const data = await response.text();

    // Parse e retorno da resposta
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, "text/html");
    return doc.querySelectorAll('.product-block');
  },

  getNextPage: async function () {
    const _this = this;
    const currentPage = _this.pagination.current_page;
    const wrapper = _this.productsWrapper;

    if (!wrapper.classList.contains('searching')) {

      // Busca e adiciona novos produtos
      _this.productsWrapper.classList.add('searching');
      const newProducts = await _this.loadProducts();
      newProducts.forEach(product => { wrapper.appendChild(product) });

      // Atualiza página atual carregada e próxima etapa se tiver
      _this.setCurrentPage(currentPage + 1);

      // Atualiza o lazy load
      lazyLoadInstance.update();

      // libera o processo de busca de novas páginas
      wrapper.classList.remove('searching');
    }
  },

  init: function () {
    const _this = this;
    const loadEl = _this.loadEl;

    // Verifica se há paginação definida antes de iniciar
    if (typeof _this.pagination != undefined) {

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })

      if (loadEl != null) {
        const observer = new IntersectionObserver((entries) => {
          // isIntersecting retorna True quando o elemento entra em página
          if (entries[0].isIntersecting) _this.getNextPage();

          // threshold 1 só chama o callback acima quando o elemento observado estiver full na tela
        }, { threshold: 1 });

        observer.observe(loadEl);
      }
    }
  }
}

window.infiniteScroll.init();
